import { render } from "./eye-open.svg?vue&type=template&id=469fd793"
const script = {}
script.render = render

export default script